module.exports = __webpack_public_path__ + "media/images/sunbit_logo-c7170c8db279b3b9e7760ba73d78d678.png";